import { render, staticRenderFns } from "./AddComments.vue?vue&type=template&id=4ebbb79c&"
import script from "./AddComments.vue?vue&type=script&lang=js&"
export * from "./AddComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports